var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgCustomerCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_5300_110409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 3.33268C8.23173 3.33268 6.53604 4.03506 5.28579 5.2853C4.03555 6.53555 3.33317 8.23124 3.33317 9.99935H5.83317C6.2752 9.99935 6.69912 10.1749 7.01168 10.4875C7.32424 10.8001 7.49984 11.224 7.49984 11.666V15.8327C7.49984 16.2747 7.32424 16.6986 7.01168 17.0112C6.69912 17.3238 6.2752 17.4993 5.83317 17.4993H3.33317C2.89114 17.4993 2.46722 17.3238 2.15466 17.0112C1.8421 16.6986 1.6665 16.2747 1.6665 15.8327V9.99935C1.6665 5.39685 5.39734 1.66602 9.99984 1.66602C14.6023 1.66602 18.3332 5.39685 18.3332 9.99935V15.8327C18.3332 16.2747 18.1576 16.6986 17.845 17.0112C17.5325 17.3238 17.1085 17.4993 16.6665 17.4993H14.1665C13.7245 17.4993 13.3006 17.3238 12.988 17.0112C12.6754 16.6986 12.4998 16.2747 12.4998 15.8327V11.666C12.4998 11.224 12.6754 10.8001 12.988 10.4875C13.3006 10.1749 13.7245 9.99935 14.1665 9.99935H16.6665C16.6665 8.23124 15.9641 6.53555 14.7139 5.2853C13.4636 4.03506 11.7679 3.33268 9.99984 3.33268ZM3.33317 11.666V15.8327H5.83317V11.666H3.33317ZM14.1665 11.666V15.8327H16.6665V11.666H14.1665Z",
    fill: "#002244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5300_110409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCustomerCare);
export default __webpack_public_path__ + "static/media/svg_customer_care.c220a4ae449827a7251a562199c8824c.svg";
export { ForwardRef as ReactComponent };